import React, { useEffect } from 'react';
import { useSelector } from 'react-redux';
import { getRegion } from '../../../utils/Region';
import { pushGTMEvent } from '../../Player/utils/analytics';
import { get } from 'utils/LocalStorageUtil';

const EVENT_NAME = 'suspension';
const LOCAL_STORAGE_USER_INFO = 'getUserInfo';

export const useGoogleAnalytics = isUserSuspended => {
  const stateUserId = useSelector(state => state.user.userId);

  useEffect(
    () => {
      if (!isUserSuspended) return;

      const storageUserId = get(LOCAL_STORAGE_USER_INFO)?.id_usuario;
      const region = getRegion().toLowerCase();

      pushGTMEvent({
        event: EVENT_NAME,
        user_id: stateUserId ?? storageUserId ?? '',
        country: region,
      });
    },
    [isUserSuspended],
  );
};
